const PropTypes = require('prop-types');
const React = require('react');

const RelatedArticles = require('components/shared/related_articles.jsx');
const BumpRetargeting = require('./bump_retargeting.jsx');
const SimilarListings = require('./similar_listings.jsx');

const UrlHelpers = require('components/shared/url_helpers.js');
const APIRequest = require('components/api_request.js');

class RelatedContent extends React.Component {
  constructor() {
    super();

    this.state = {
      articles: [],
    };
  }

  componentDidMount() {
    this.fetchArticles();
  }

  fetchArticles() {
    const url = UrlHelpers.listingRelatedArticlesPath(this.props.listingId);
    APIRequest.V3.get(url).then((response) => {
      this.setState({ articles: response.articles });
    });
  }

  render() {
    return (
      <div>
        <RelatedArticles articles={this.state.articles} />
        <BumpRetargeting listingId={this.props.listingId} />
        <SimilarListings
          listingId={this.props.listingId}
        />
      </div>
    );
  }
}

RelatedContent.propTypes = {
  listingId: PropTypes.string.isRequired,
};

module.exports = RelatedContent;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/related_content.jsx